import {
  Button,
  FormControl,
  FormLabel,
  FormHelperText,
  IconButton,
  Input,
  Stack,
  Typography,
} from "@mui/joy";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import useForcePasswordChangeForm from "./utils/useForcePasswordChangeForm";

type Props = {
  username: string;
};

const ForcePasswordChangeForm = ({ username }: Props) => {
  const {
    isLoading,
    formValue,
    updateFormValue,
    showNewPassword,
    setShowNewPassword,
    showConfirmPassword,
    setShowConfirmPassword,
    onSubmit,
    passwordsMatch,
  } = useForcePasswordChangeForm({ username });

  return (
    <Stack spacing={2} sx={{ justifyContent: "start", width: 1 }}>
      <Stack
        direction={{ md: "row" }}
        spacing={2}
        alignItems={{ xs: "center", md: "end" }}
      >
        <Typography level="h1" sx={{ lineHeight: 1 }}>
          Change Password
        </Typography>
      </Stack>
      <Typography level="body-md" textAlign={{ xs: "center", md: "left" }}>
        Your administrator requires you to change your password before continuing.
      </Typography>

      <Stack spacing={2} sx={{ pt: 1 }}>
        <form onSubmit={onSubmit} style={{ gap: "1rem", display: "grid" }}>
          <FormControl>
            <FormLabel>Email</FormLabel>
            <Input
              type="text"
              name="username"
              value={username}
              disabled
              sx={{ opacity: 0.7 }}
            />
          </FormControl>

          <FormControl required>
            <FormLabel>New Password</FormLabel>
            <Input
              type={showNewPassword ? "text" : "password"}
              name="newPassword"
              placeholder="Enter new password"
              value={formValue.newPassword}
              onChange={(e) => updateFormValue("newPassword", e.target.value)}
              endDecorator={
                <IconButton onClick={() => setShowNewPassword(!showNewPassword)}>
                  {showNewPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              }
            />
            <FormHelperText>
              Password must be at least 8 characters and include uppercase, lowercase, and numbers.
            </FormHelperText>
          </FormControl>

          <FormControl required error={!passwordsMatch && formValue.confirmPassword !== ""}>
            <FormLabel>Confirm New Password</FormLabel>
            <Input
              type={showConfirmPassword ? "text" : "password"}
              name="confirmPassword"
              placeholder="Confirm new password"
              value={formValue.confirmPassword}
              onChange={(e) => updateFormValue("confirmPassword", e.target.value)}
              endDecorator={
                <IconButton onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                  {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              }
            />
            {!passwordsMatch && formValue.confirmPassword !== "" && (
              <FormHelperText>Passwords do not match</FormHelperText>
            )}
          </FormControl>

          <Stack gap={2} sx={{ mt: 2 }}>
            <Button 
              type="submit" 
              loading={isLoading} 
              fullWidth 
              size="lg"
              disabled={!passwordsMatch || formValue.newPassword.length < 8}
            >
              Change Password
            </Button>
          </Stack>
        </form>
      </Stack>
    </Stack>
  );
};

export default ForcePasswordChangeForm;
